import mybom from './mybotton'
const mybottom = {
  install: (Vue) => {
    Vue.component('mybottom', mybom)
  }
}
export default mybottom



//////////////////
// WEBPACK FOOTER
// ./src/components/Mybottom/index.js
// module id = null
// module chunks = 